/**
 * Module definition houses accessibilty-based components.
 *
 * @module stack.common.ui.loader
 */
angular.module('stack.common.ui.loader', [
  'stack.common.ui.loader.stackLoader'
]);
